<template>
  <div :style="style">
    <div class="icon">
      <font-awesome-icon
        :icon="['fal', 'exclamation-triangle']"
        :size="iconSize"
      />
    </div>
    <p></p>
    <h4 :style="styleFontSize">
      {{ exceptionMessage }}
    </h4>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faExclamationTriangle,
} from '@fortawesome/pro-light-svg-icons';

library.add(
  faExclamationTriangle,
);

export default {
  props: {
    exceptionMessage: {
      type: String,
      required: true,
    },
    margin: {
      type: String,
      default: '6.5rem',
    },
    iconSize: {
      type: String,
      default: '2x',
    },
    fontSize: {
      type: String,
      default: '14px',
    },
  },
  computed: {
    style() {
      return `margin: ${this.margin}`;
    },
    styleFontSize() {
      return `font-size: ${this.fontSize}`;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
